import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { User } from '../interfaces'

import { AppRoute } from '@shared/config'

export const getTeamEditPath = (teamId: number | string): string => `${AppRoute.Teams}/${teamId}`

export const toMemberOptions = (users: User[]): AppSelectOption<number>[] =>
  users.map(user => ({ value: user.id, text: user.name }))
